import React from 'react';

import styles from './Link.module.scss';

interface LinkProps {
    children: React.ReactNode;
    path: string;
}

const Link = ({ children, path }: LinkProps) => {
    return (
        <a href={path} className={styles.link} target="_blank" rel="noreferrer">
            {children}
        </a>
    );
};

export default Link;
